mutation InviteOrganizationUser($input: InviteOrganizationUserInput!) {
  inviteOrganizationUser(input: $input) {
    id
    roles
    disabled
    welcomeEmailSentAt
    createdAt
    user {
      id
      email
      displayName
    }
  }
}
